import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Navbar.scss';
import images from '../../assets';

function Navbar() {
    const navigate = useNavigate();
    const location = useLocation();

    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
            setScrolled(scrollPosition > 10);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const navList = [
        { label: 'Home', link: '/' },
        { label: 'Services', link: '/services' },
        { label: 'Projects', link: '/projects' },
        { label: 'About us', link: '/about' },
        { label: 'Contact', link: '/contact' },
    ];

    const navigateToHome = () => {
        navigate('/');
    };

    const handleOpen = () => {
        setOpen((open) => !open);
    };

    return (
        <nav className="navbar">
            {/* Desktop View  */}
            <ul className="nav-container">
                <ul className="nav-logo" onClick={navigateToHome}>
                    <img alt="topnotch logo" src={images?.navLogo} />
                </ul>
                <ul className="nav-items-wrap">
                    {navList?.map((navItem) => (
                        <Link
                            to={navItem.link}
                            key={navItem?.label}
                            className="nav-item"
                        >
                            {location?.pathname === navItem?.link && (
                                <div className="active-link" />
                            )}
                            {navItem?.label}
                        </Link>
                    ))}
                </ul>
            </ul>

            {/* Mobile/Tablet View */}
            <nav className="nav-container-mobile">
                <div className={`nav-header ${scrolled ? 'scrolled' : ''}`}>
                    <ul className="nav-logo" onClick={navigateToHome}>
                        <img alt="topnotch logo" src={images?.navLogo} />
                    </ul>
                    {open ? (
                        <ul className="nav-icon" onClick={handleOpen}>
                            <svg viewBox="0 0 24 24">
                                <path d="M5.3,18.7C5.5,18.9,5.7,19,6,19s0.5-0.1,0.7-0.3l5.3-5.3l5.3,5.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3   c0.4-0.4,0.4-1,0-1.4L13.4,12l5.3-5.3c0.4-0.4,0.4-1,0-1.4s-1-0.4-1.4,0L12,10.6L6.7,5.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4   l5.3,5.3l-5.3,5.3C4.9,17.7,4.9,18.3,5.3,18.7z" />
                            </svg>
                        </ul>
                    ) : (
                        <ul className="nav-icon" onClick={handleOpen}>
                            <svg viewBox="0 0 32 32">
                                <path d="M4,10h24c1.104,0,2-0.896,2-2s-0.896-2-2-2H4C2.896,6,2,6.896,2,8S2.896,10,4,10z M28,14H4c-1.104,0-2,0.896-2,2  s0.896,2,2,2h24c1.104,0,2-0.896,2-2S29.104,14,28,14z M28,22H4c-1.104,0-2,0.896-2,2s0.896,2,2,2h24c1.104,0,2-0.896,2-2  S29.104,22,28,22z" />
                            </svg>
                        </ul>
                    )}
                </div>
                <div
                    className={`nav-content-mobile ${open ? 'displayNav' : 'hideNav'}`}
                >
                    {navList?.map((navItem) => (
                        <Link
                            to={navItem.link}
                            key={navItem?.label}
                            className="nav-item-mobile"
                            onClick={() => setOpen(false)}
                        >
                            {location?.pathname === navItem?.link && (
                                <div className="active-link-mobile" />
                            )}
                            {navItem?.label}
                        </Link>
                    ))}
                </div>
            </nav>
        </nav>
    );
}

export default Navbar;
